'use client'

import type { ComponentProps } from 'react'
import { useTranslations } from 'next-intl'
import toast from 'react-hot-toast'
import { LinkIcon } from 'lucide-react'
import { MenuItem } from './MenuItem'

/** "Copy link", confirming with a toast or saying the clipboard refused. */
export function CopyLinkMenuItem({
  href,
  ...props
}: Omit<
  ComponentProps<typeof MenuItem>,
  'href' | 'icon' | 'onClick' | 'children'
> & {
  /** The link to copy, relative to the page; the page's own when absent. */
  href?: string
}) {
  const t = useTranslations('CopyLink')
  return (
    <MenuItem
      {...props}
      icon={LinkIcon}
      onClick={async () => {
        try {
          const page = window.location.href
          await navigator.clipboard.writeText(
            new URL(href ?? page, page).toString(),
          )
          toast.success(t('copied'))
        } catch {
          toast.error(t('failed'))
        }
      }}
    >
      {t('label')}
    </MenuItem>
  )
}
